// @flow weak

import React, { Component } from 'react';
import PropTypes    from 'prop-types';
import UserMenu     from './userMenu/UserMenu';
import TaskMenu     from './taskMenu/TaskMenu';
import MessageMenu  from './messageMenu/MessageMenu';
import Button       from './button/Button';
import { createBrowserHistory } from "history";
import isEmpty        from "lodash.isempty";
import { withRouter } from "react-router-dom";
import { compose }    from "redux";
import headerLogo from '../../img/ddb.png'
const history = createBrowserHistory();

class Header extends Component{
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      filterType: "customerEmail",
      filterText: ""
    };

    this.handleCustomerSearch = this.handleCustomerSearch.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentWillMount(){
    if (localStorage.getItem("userTypeName") == "customer" || localStorage.getItem("userTypeName") == "guest_user") {
      this.context.router.history.push("/");
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.location && nextProps.location.pathname.indexOf('/search/') ==0){
      let filterArray = nextProps.location.pathname.split("/");
      if(!isEmpty(filterArray)){
        this.setState({
          filterType:filterArray[2],
          filterText:filterArray[3]
        });
      }
    }
    else
    {
      this.setState({
        filterType: "customerEmail",
        filterText: ""
      });
    }
  }

  handleInputChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  };

  handleCustomerSearch() {
    if(!isEmpty(this.state.filterText)){
      this.context.router.history.push(`/search/`+this.state.filterType+'/'+this.state.filterText);
    }
  }

  render(){

    const {
      appName,
      currentView,
      userLogin,
      userFirstname,
      userLastname,
      userPicture,
      showPicture,
      toggleSideMenu,
      onLogout
    } = this.props;

    var TextStyle = {
      // width: '40%',
      // marginRight: '50px'
    }

    return(
        <header
          className="header fixed--header">
          <a href="/" className="logo">{/* { appName } */}<img src={headerLogo} className="pull-left" width="170px" /></a>
          <nav className="navbar navbar-static-top" role="navigation">
                <Button toggleSideMenu={toggleSideMenu} />
                <img src={headerLogo} className="mobile-logo" />
                <div className="navbar-right" style={TextStyle}>
                  <div className="customerSearch">
                    <div className="row ">
                      <div className="col-xs-5">
                        <select
                          name="filterType"
                          className="form-control"
                          value={this.state.filterType}
                          onChange={this.handleInputChange} >
                          <option value="customerEmail">Customer Email</option>
                          <option value="customerName">Customer Name</option>
                          <option value="orderID">Order ID</option>
                          <option value="offers">Offers</option>
                          <option value="vouchers">Voucher Code</option>
                        </select>
                      </div>
                      <div className="col-xs-5">
                        <input
                          type="text"
                          className="form-control"
                          name="filterText"
                          autoComplete="off"
                          id="filterText"
                          placeholder="Enter Text"
                          value={this.state.filterText}
                          onChange={this.handleInputChange}
                        />
                      </div>
                      <div className="col-xs-2">
                        <button
                          id="send"
                          onClick={this.handleCustomerSearch}
                          type="submit"
                          className="btn btn-success"
                        >
                          <i className="glyphicon glyphicon-search" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </nav>
        </header>
      )
  }
}

// const Header = ({
//   userLogin,
//   userFirstname,
//   userLastname,
//   userPicture,
//   showPicture,
//   appName,
//   toggleSideMenu,
//   onLogout
// }) => ();

Header.propTypes = {
  appName:        PropTypes.string,
  userLogin:      PropTypes.string,
  userFirstname:  PropTypes.string,
  userLastname:   PropTypes.string,
  userPicture:    PropTypes.string,
  showPicture:    PropTypes.bool,
  onLogout:       PropTypes.func,
  currentView:    PropTypes.string,
  toggleSideMenu: PropTypes.func
};

Header.defaultProps = {
  appName: 'applicationName'
};

Header.displayName = 'Header';

export default  compose(withRouter)(Header);



// WEBPACK FOOTER //
// ./src/app/components/header/Header.js